module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    class: {
      'active': _vm.tab == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(2)
      }
    }
  }, [_c('a', [_vm._v("配料")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 20
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(20)
      }
    }
  }, [_c('a', [_vm._v("配料群組")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(10)
      }
    }
  }, [_c('a', [_vm._v("商品分類")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(1)
      }
    }
  }, [_c('a', [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 11
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(11)
      }
    }
  }, [_c('a', [_vm._v("品項選擇區")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(3)
      }
    }
  }, [_c('a', [_vm._v("套餐")])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline"
  }, [_c('nd-binding-table', {
    attrs: {
      "bindList": _vm.bindList,
      "bindMeta": _vm.bindMeta,
      "tab": _vm.tab,
      "skey": _vm.skey,
      "input": _vm.input,
      "sPage": _vm.sPage,
      "getBindingList": _vm.getBindingList,
      "selectAll": _vm.selectAll,
      "isDeleteStatus": _vm.isDeleteStatus
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78903409"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/binding-pos.vue
// module id = 2487
// module chunks = 1